<template>
  <div class="suggest">
    <input
      :class="['form-control', classname]"
      :id="id"
      :required="required"
      :value="focused ? q : value"
      @blur="blur"
      @focus="focus"
      @input="search($event.target.value)"
      @keydown.down.prevent.stop="down"
      @keydown.enter.prevent.stop="select_active"
      @keydown.tab="select_active"
      @keydown.up.prevent.stop="up"
      @keydown.esc.prevent.stop="clear"
      autocomplete="off"
      ref="input"
      type="text"
    />
    <transition name="fade">
      <ul class="dropdown-menu w-100 mt-1 show" v-if="focused && options.length">
        <button
          :class="{'highlight': active === i}"
          :key="option.id"
          @click="select(option)"
          @mousedown="select(option)"
          @mouseover="active = i"
          class="dropdown-item"
          type="button"
          v-for="(option, i) in options">
          {{ option.title }}
          <small class="d-block" v-if="option.subtitle">
            {{ option.subtitle }}
          </small>
        </button>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  props: [
    'id',
    'required',
    'classname',
    'value',
    'options',
    'index'
  ],
  data () {
    return {
      q: '',
      focused: false,
      active: 0
    }
  },
  watch: {
    options () {
      this.active = 0
    }
  },
  methods: {
    focus () {
      this.q = ''
      this.focused = true
    },
    blur () {
      this.focused = false
    },
    search (v) {
      this.q = v
      this.$emit('search', v)
    },
    up () {
      if (this.active > 0) {
        this.active--
      }
    },
    down () {
      if (this.active < this.options.length - 1) {
        this.active++
      }
    },
    select_active () {
      if (this.options[this.active]) {
        this.select(this.options[this.active])
      }
    },
    select (item) {
      this.$emit('select', {'item': item, 'index': this.index})
      this.$refs.input.blur()
    },
    clear () {
      this.$emit('clear', {'index': this.index})
      this.$refs.input.blur()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Suggest.vue